var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body_monban"},[_c('el-tabs',{staticStyle:{"height":"200px"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"退款管理","name":"tuikuan"}},[_c('tuikuan',{attrs:{"admin_flag":0}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }